// The On sale cell: whether the reseller sells the TLD, saved as soon as it is switched. Switching
// on a TLD without a selling price for registration is refused by the API, and said so here.
// Fixed for a reseller not active yet.
import type { ResellerTld } from "@kilat/contracts/reseller-pricing";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { ApiError } from "@/lib/api-client";
import { m } from "@/lib/paraglide/messages.js";
import { pricingError } from "../pricing-error";
import { useSetTldEnabled } from "./mutation";

export function TldEnabledSwitch({ tld, editable }: { tld: ResellerTld; editable: boolean }) {
  const toggle = useSetTldEnabled(tld.id);
  const name = `.${tld.tld}`;

  function change(enabled: boolean) {
    toggle.mutate(enabled, {
      onSuccess: () =>
        toast.success((enabled ? m.reseller_pricing_enabled_on : m.reseller_pricing_enabled_off)({ tld: name })),
      onError: (error) =>
        toast.error(
          error instanceof ApiError && error.code === "tld_unpriced"
            ? m.reseller_pricing_unpriced({ tld: name })
            : pricingError(error),
        ),
    });
  }

  return (
    <Switch
      checked={tld.enabled}
      disabled={!editable || toggle.isPending}
      aria-label={m.reseller_pricing_enabled_label({ tld: name })}
      onCheckedChange={change}
    />
  );
}
